import commonType, { CommonState, ICommonAction } from "./common.type";

const initialState: CommonState = {
  isLoading: false,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: ICommonAction) => {
  switch (action.type) {
    /**
     * Show loading
     */
    case commonType.LOADING.SHOW:
      return {
        ...state,
        isLoading: true,
      };
    /**
     * Hide loading
     */
    case commonType.LOADING.HIDE:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};
